import buttonFormFields from '@/components/sections/form-fields/content/button'
import generalSectionFormFields from '@/components/sections/form-fields/design/section'
import contentBoxFormFields from '@/components/sections/form-fields/layout/category-content-box'
import structureFormFields from '@/components/sections/form-fields/layout/structure'

export const content = {
  title: { label: 'Title', type: 'text' },
  introtext: { label: 'Introtext', type: 'text-editor' },
  articles: {
    label: 'Articles',
    type: 'repeatable',
    fields: {
      'article-title': {
        label: 'Article title',
        type: 'text',
        rules: ['required']
      },
      'article-introtext': {
        label: 'Article introtext',
        type: 'text-editor',
        hideOnList: true
      },
      'article-image': {
        label: 'Article image',
        type: 'media-manager',
        hideOnList: true
      },
      ...buttonFormFields
    }
  }
}

export const design = {
  ...generalSectionFormFields,
  'title-color': {
    label: 'Title color',
    type: 'text-color',
    category: 'Category text'
  },
  'title-font-weight': {
    label: 'Title font weight',
    type: 'radio',
    options: [
      { value: 'var(--title-font-weight)', text: 'Default' },
      { value: 'lighter', text: 'Light' },
      { value: 'bold', text: 'Bold' }
    ],
    category: 'Category text'
  },
  'title-tag': {
    label: 'Title header type',
    type: 'radio',
    options: [
      { value: 'h1', text: 'Heading 1' },
      { value: 'h2', text: 'Heading 2' },
      { value: 'h3', text: 'Heading 3' },
      { value: 'h4', text: 'Heading 4' },
      { value: 'h5', text: 'Heading 5' },
      { value: 'h6', text: 'Heading 6' }
    ],
    category: 'Category text'
  },
  'introtext-color': {
    label: 'Introtext color',
    type: 'text-color',
    category: 'Category text'
  },
  'article-title-color': {
    label: 'Article title color',
    type: 'text-color',
    category: 'Article text'
  },
  'article-title-font-weight': {
    label: 'Article title font weight',
    type: 'radio',
    options: [
      { value: 'var(--title-font-weight)', text: 'Default' },
      { value: 'lighter', text: 'Light' },
      { value: 'bold', text: 'Bold' }
    ],
    category: 'Article text'
  },
  'article-title-tag': {
    label: 'Article title header type',
    type: 'radio',
    options: [
      { value: 'h1', text: 'Heading 1' },
      { value: 'h2', text: 'Heading 2' },
      { value: 'h3', text: 'Heading 3' },
      { value: 'h4', text: 'Heading 4' },
      { value: 'h5', text: 'Heading 5' },
      { value: 'h6', text: 'Heading 6' }
    ],
    category: 'Article text'
  },
  'article-introtext-color': {
    label: 'Article introtext color',
    type: 'text-color',
    category: 'Article text'
  }
}

export const layout = {
  ...structureFormFields,
  'article-columns': {
    label: 'Maximum articles per row',
    type: 'radio',
    options: [
      { value: '1', text: 'One' },
      { value: '2', text: 'Two' },
      { value: '3', text: 'Three' },
      { value: '4', text: 'Four' },
      { value: '6', text: 'Six' }
    ],
    category: 'Structure'
  },
  ...contentBoxFormFields
}

export const advanced = {}

export default {
  content,
  design,
  layout,
  advanced
}
